module.exports = __webpack_public_path__ + "static/img/aguardando.7cc9308.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aguardando.gif
// module id = qkh1
// module chunks = 1